import { render } from "./PreSentationtwo.vue?vue&type=template&id=a8374baa"
const script = {}

import exportComponent from "../../../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/icons/package/PreSentationtwo.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "a8374baa"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('a8374baa', __exports__)) {
    api.reload('a8374baa', __exports__)
  }
  
  module.hot.accept("./PreSentationtwo.vue?vue&type=template&id=a8374baa", () => {
    api.rerender('a8374baa', render)
  })

}


export default __exports__